// client/src/i18n/translations/ar.js — Maxula
// Dictionnaire ARABE. Toute clé absente retombe sur le français (jamais
// d'écran cassé). Chiffres OCCIDENTAUX pour les prix et numéros de
// commande (convention commerciale marocaine).
const ar = {
  // ---- Navigation ----
  'nav.home': 'الرئيسية',
  'nav.categories': 'الفئات',
  'nav.cities': 'المدن',
  'nav.newest': 'الجديد',
  'nav.bestOffers': 'أفضل العروض',
  'nav.merchants': 'التجار',
  'nav.subscriptions': 'الاشتراكات',
  'nav.support': 'الدعم',
  'nav.searchPlaceholder': 'ابحث عن العروض...',
  'nav.seeAllResults': 'عرض جميع النتائج لـ « {{q}} »',
  'nav.deals': 'العروض',
  'nav.login': 'تسجيل الدخول',
  'nav.register': 'إنشاء حساب',
  'nav.logout': 'تسجيل الخروج',
  'nav.myAccount': 'حسابي',
  'nav.dashboard': 'لوحة التحكم',

  // ---- Commun ----
  'common.seeAll': 'عرض الكل',
  'common.seeMore': 'عرض المزيد',
  'common.loading': 'جارٍ التحميل...',
  'common.apply': 'تطبيق',
  'common.reset': 'إعادة تعيين الفلاتر',
  'common.previous': 'السابق',
  'common.next': 'التالي',
  'common.page': 'صفحة',
  'common.currency': 'درهم',
  'common.search': 'بحث',
  'common.prevShort': 'السابق',
  'common.nextShort': 'التالي',
  'common.show': 'إظهار',
  'common.perPage': '/ صفحة',

  // ---- Recherche (page /search) ----
  'search.resultsFor': 'نتائج البحث عن « {{q}} »',
  'search.allDeals': 'جميع العروض',
  'search.results_one': '{{count}} نتيجة',
  'search.results_other': '{{count}} نتائج',
  'search.filters': 'الفلاتر',
  'search.activeFilters_one': 'فلتر واحد نشط',
  'search.activeFilters_other': '{{count}} فلاتر نشطة',
  'search.sortBy': 'ترتيب حسب',
  'search.sort.newest': 'الأحدث',
  'search.sort.priceAsc': 'السعر تصاعدياً',
  'search.sort.priceDesc': 'السعر تنازلياً',
  'search.sort.discount': 'أكبر تخفيض',
  'search.sort.popular': 'الأكثر شعبية',
  'search.price': 'السعر (درهم)',
  'search.min': 'الأدنى',
  'search.max': 'الأقصى',
  'search.categories': 'الفئات',
  'search.cities': 'المدن',
  'search.noResults': 'لا توجد نتائج',
  'search.noResultsHint': 'جرّب كلمات أخرى أو وسّع نطاق الفلاتر.',
  'search.viewAllDeals': 'عرض جميع العروض',

  // ---- Accueil ----
  'home.heroTitle': 'اكتشف أفضل العروض في المغرب',
  'home.heroSubtitle': 'وفّر حتى 90% على المطاعم والسبا والأسفار والمزيد',
  'home.exploreDeals': 'استكشف العروض',
  'home.howItWorks': 'كيف يعمل الموقع',
  'home.howItWorksSub': 'استفد من أفضل العروض في 3 خطوات بسيطة',
  'home.step1': '1. اعثر على عرضك',
  'home.step1Sub': 'تصفّح عروضنا حسب الفئات',
  'home.step2': '2. اشترِ عبر الإنترنت',
  'home.step2Sub': 'ادفع إلكترونياً واستلم قسيمتك',
  'home.step3': '3. استمتع بالعرض',
  'home.step3Sub': 'قدّم قسيمتك واستمتع',
  // بطاقات الصفحة الرئيسية (4 لافتات قابلة للنقر)
  'home.tilesSub': 'اختر مجالك وادخل مباشرة إلى العروض',
  'home.tilesCta': 'عرض العروض',
  'home.tilesDeals': 'عروض',
  // كتلة الهاتف (MobileDiscover)
  'home.mobileTitle': 'أفضل العروض بالقرب منك',
  'home.mobileSub': 'اختر مجالاً واحجز في بضع نقرات',
  'home.mobileAllCategories': 'عرض الكل',
  'home.popularCategories': 'الفئات الشائعة',
  'home.popularCategoriesSub': 'اكتشف عروضنا حسب الفئة',
  'home.featuredSub': 'اكتشف أفضل عروضنا الحالية',
  'home.allDealsSub': 'اكتشف جميع العروض المتاحة',
  'home.noCategory': 'لا توجد فئات',
  'home.noDeals': 'لا توجد عروض متاحة',
  'home.noFeatured': 'لا توجد عروض مميزة',

  // ---- Pied de page ----
  'footer.company': 'الشركة',
  'footer.poles': 'أقسامنا',
  'footer.contact': 'اتصل بنا',

  // ---- Suggestions ----
  'sugg.deals': 'العروض',
  'sugg.merchants': 'التجار',
  'sugg.categories': 'الفئات',

  // ---- Bannière publicitaire (sponsorisée) ----
  'ad.sponsored': 'إعلان مموّل',
  'ad.cta': 'اكتشف العرض',
  'ad.close': 'إغلاق',

  // ---- (v1.177) الصفحة الرئيسية: عناوين الأقسام ----
  'home.featured': 'عروض مميزة',
  'home.allDeals': 'جميع العروض',
  'home.seeAllDeals': 'عرض كل العروض',
  'home.dealsByCity': 'عروض حسب المدينة',
  'home.dealsByCitySub': 'اعثر على عروض بالقرب منك أو اكتشف مدنًا جديدة.',
  'home.offers': 'عروض',
  'home.categoriesCount': 'فئات',
  'home.citiesCount': 'مدن',
  'home.noCities': 'لا توجد مدن متاحة حالياً.',

  // ---- (v1.177) بطاقة العرض ----
  'deal.viewOffer': 'شاهد العرض',
  'deal.bought': 'تم شراؤها',
  'deal.available': 'متاح',
  'deal.limitedStock': 'مخزون محدود',
  'deal.day': 'يوم',
  'deal.days': 'أيام',
  'deal.ongoing': 'جارٍ',
  'deal.expired': 'منتهي',
  'deal.addToCart': 'أضف إلى السلة',

  // ---- (v1.177) تذييل الصفحة: روابط وإشعارات ----
  'footer.tagline': 'منصة بريميوم للحجز والوساطة بين العملاء والشركاء (سبا، تجميل، مطاعم، فنادق، أسفار، عقارات، خدمات VIP…).',
  'footer.since': 'منذ 2013 • موثوق • شفّاف • بريميوم',
  'footer.exploreDeals': 'استكشف العروض',
  'footer.about': 'من نحن',
  'footer.becomePartner': 'كن شريكاً',
  'footer.contactLink': 'اتصل بنا',
  'footer.faq': 'الأسئلة الشائعة',
  'footer.getInTouch': 'تواصل معنا',
  'footer.cgv': 'الشروط العامة للبيع',
  'footer.terms': 'شروط الاستخدام',
  'footer.privacy': 'سياسة الخصوصية',
  'footer.legal': 'الإشعارات القانونية',
  'footer.intermediary': 'تعمل Maxula كوسيط بين العملاء والشركاء. تُقدَّم الخدمات من طرف الشركاء. (راجع الشروط العامة للبيع للتفاصيل.)',

  'footer.rights': 'جميع الحقوق محفوظة.',
  'footer.hours': 'الإثنين–السبت • 10:00 – 19:00',

  // ---- (v1.178) صفحة الدعم ----
  'support.title': 'الدعم والمساعدة',
  'support.subtitle': 'تواصل معنا، نردّ عليك بسرعة.',
  'support.sendTitle': 'أرسل رسالة إلى الدعم',
  'support.name': 'اسمك',
  'support.email': 'البريد الإلكتروني',
  'support.phone': 'الهاتف',
  'support.message': 'رسالتك…',
  'support.send': 'إرسال',
  'support.sending': 'جارٍ الإرسال…',
  'support.writeMessage': 'اكتب رسالتك',
  'support.sent': 'تم إرسال الرسالة إلى الدعم!',
  'support.error': 'حدث خطأ أثناء الإرسال'
};

export default ar;